var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("popup", {
    attrs: {
      env: _vm.env,
      type: _vm.type,
      slug: _vm.slug,
      visible: _vm.visible,
      title: _vm.couponInfo.title,
      subtitle: _vm.couponInfo.subtitle,
      imageUrl: _vm.couponInfo.imageUrl,
      buttonText: _vm.couponInfo.buttonText,
      buttonIcon: "download",
    },
    on: {
      "update:visible": function ($event) {
        _vm.visible = $event
      },
      callback: _vm.callback,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }